// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin {
  align-items: center;
  text-align: center;
  padding: 0 28px;
}

.signin__hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.signin__logo {
  width: 132px;
  height: auto;
  transform: scaleX(-1);
  filter: drop-shadow(0 8px 14px rgba(28, 27, 26, 0.16));
}

.signin__word {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 2.6rem;
  line-height: 1;
}

.signin__tag {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.62rem;
  line-height: 1.16;
  margin: 4px 0 0;
}

.signin__pitch {
  color: var(--palette-text-muted);
  font-size: 0.98rem;
  line-height: 1.5;
  max-width: 316px;
  margin: 8px 0 0;
}

.signin__auth {
  width: 100%;
  max-width: 340px;
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 34px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.signin__microcopy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: var(--palette-text-muted);
  font-size: 0.86rem;
  margin: -2px 0 8px;
}
.signin__free {
  font-weight: 700;
  font-size: 0.92rem;
  color: var(--palette-text);
}

.signin__google {
  display: flex;
  justify-content: center;
  min-height: 44px;
}

.signin__signing {
  color: var(--palette-text-muted);
  padding: 14px 0;
}

.signin__error {
  color: #b3261e;
  font-size: 0.86rem;
}

.signin__foot {
  font-size: 0.74rem;
  color: var(--palette-text-muted);
  margin-top: 8px;
  line-height: 1.5;
}
.signin__foot a {
  color: var(--palette-secondary);
  text-decoration: none;
}

.signin__link {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: var(--palette-secondary);
  text-decoration: none;
  cursor: pointer;
}

.signin__name {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.signin__defn {
  text-align: center;
  max-width: 300px;
}
.signin__defn-head {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1rem;
}
.signin__defn-head .pron {
  font-weight: 400;
  font-style: italic;
  color: var(--palette-text-muted);
  font-size: 0.88rem;
}
.signin__defn-head .pos {
  font-style: italic;
  color: var(--palette-primary);
  font-size: 0.88rem;
}
.signin__defn-body {
  display: block;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 0.95rem;
  line-height: 1.4;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/signInScreen.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".signin {\n  align-items: center;\n  text-align: center;\n  padding: 0 28px;\n}\n\n.signin__hero {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n}\n\n.signin__logo {\n  width: 132px;\n  height: auto;\n  transform: scaleX(-1);\n  filter: drop-shadow(0 8px 14px rgba(28, 27, 26, 0.16));\n}\n\n.signin__word {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 2.6rem;\n  line-height: 1;\n}\n\n.signin__tag {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.62rem;\n  line-height: 1.16;\n  margin: 4px 0 0;\n}\n\n.signin__pitch {\n  color: var(--palette-text-muted);\n  font-size: 0.98rem;\n  line-height: 1.5;\n  max-width: 316px;\n  margin: 8px 0 0;\n}\n\n.signin__auth {\n  width: 100%;\n  max-width: 340px;\n  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 34px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.signin__microcopy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: var(--palette-text-muted);\n  font-size: 0.86rem;\n  margin: -2px 0 8px;\n}\n.signin__free {\n  font-weight: 700;\n  font-size: 0.92rem;\n  color: var(--palette-text);\n}\n\n.signin__google {\n  display: flex;\n  justify-content: center;\n  min-height: 44px;\n}\n\n.signin__signing {\n  color: var(--palette-text-muted);\n  padding: 14px 0;\n}\n\n.signin__error {\n  color: #b3261e;\n  font-size: 0.86rem;\n}\n\n.signin__foot {\n  font-size: 0.74rem;\n  color: var(--palette-text-muted);\n  margin-top: 8px;\n  line-height: 1.5;\n}\n.signin__foot a {\n  color: var(--palette-secondary);\n  text-decoration: none;\n}\n\n.signin__link {\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  color: var(--palette-secondary);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.signin__name {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.signin__defn {\n  text-align: center;\n  max-width: 300px;\n}\n.signin__defn-head {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1rem;\n}\n.signin__defn-head .pron {\n  font-weight: 400;\n  font-style: italic;\n  color: var(--palette-text-muted);\n  font-size: 0.88rem;\n}\n.signin__defn-head .pos {\n  font-style: italic;\n  color: var(--palette-primary);\n  font-size: 0.88rem;\n}\n.signin__defn-body {\n  display: block;\n  font-family: var(--font-display);\n  font-style: italic;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
